import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getRiskRange = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/risk_points/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Risk data fetch error:", error);
    throw error;
  }
};

const editRiskRanges = async (ranges) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/risk_points/`,
      {
        ranges,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};
export { getRiskRange, editRiskRanges };
